module.exports = __webpack_public_path__ + "5e92bb805ff33c740702549c91bdaba5.ttf";